const IndividualPersonList = () => import(/* webpackChunkName: "IndividualPerson" */ 'RootDir/modules/IndividualPerson/IndividualPerson/List.vue');

const IndividualPersonFormWrapper = () => import(/* webpackChunkName: "IndividualPerson" */ 'RootDir/modules/IndividualPerson/IndividualPerson/FormWrapper.vue');

const IndividualPersonFormGeneralInfo = () => import(/* webpackChunkName: "IndividualPerson" */ 'RootDir/modules/IndividualPerson/IndividualPerson/FormGeneralInfoWrapper.vue');

const IndividualPersonFormHuntingTicket = () => import(/* webpackChunkName: "IndividualPerson" */ 'RootDir/modules/IndividualPerson/IndividualPerson/FormHuntingTicketWrapper.vue');

const IndividualPersonFormHuntingTicketApplications = () => import(/* webpackChunkName: "IndividualPerson" */ 'RootDir/modules/IndividualPerson/IndividualPerson/FormHuntingTicketApplicationsWrapper.vue');

const IndividualPersonFormMvdRequests = () => import(/* webpackChunkName: "IndividualPerson" */ 'RootDir/modules/IndividualPerson/IndividualPerson/FormMvdRequestsWrapper.vue');

export default [
  {
    path: 'list',
    name: 'individual-person-list',
    component: IndividualPersonList,
  },
  {
    path: 'person/:userId',
    name: 'individual-person-person',
    component: IndividualPersonFormWrapper,
    props: true,
    redirect: {
      name: 'individual-person-general-info',
      params: { userId: 'create' },
    },
    children: [
      {
        path: 'general-info',
        name: 'individual-person-general-info',
        component: IndividualPersonFormGeneralInfo,
        props: true,
      },
      {
        path: 'hunting-tickets',
        name: 'individual-person-hunting-tickets',
        component: IndividualPersonFormHuntingTicket,
        props: true,
      },
      {
        path: 'hunting-ticket-applications',
        name: 'individual-person-hunting-ticket-applications',
        component: IndividualPersonFormHuntingTicketApplications,
        props: true,
      },
      {
        path: 'mvd-requests',
        name: 'individual-person-mvd-requests',
        component: IndividualPersonFormMvdRequests,
        props: true,
      },
    ],
  },
];
